export class Connector {

  // vefuco
  // public static KRAMERIUS_URL = 'http://kramerius.digibib.genealogy.net';
  // public static UPLOAD_URL = 'http://195.201.83.34:3003/upload';
  // production
  // public static EDITOR_URL = 'https://api.digitalniknihovna.cz/editor';
  // public static FRONTEND_LINK = 'http://kramerius.digibib.genealogy.net/v/';
  // local
  // public static EDITOR_URL = 'http://localhost:3000/editor';
  // public static FRONTEND_LINK = 'http://127.0.0.1:8080/#!/vefuco/';


  // difmoe
  public static INSTANCE = 'difmoe';
  //public static KRAMERIUS_URL = 'https://kramerius.difmoe.eu';

  public static KRAMERIUS_URL = 'https://kramerius.difmoe.eu';
  
  public static ADD_PERSISTENT_LINK = true;
  public static PERSISTENT_LINK = 'https://www.difmoe.eu/d/uuid/';

  // the digitizing institution, prefilled as an extra publisher (eventType=digitization)
  public static DIGITIZATION_PUBLISHER = 'Digitales Forum Mittel- und Osteuropa';
  public static DIGITIZATION_PLACE = 'München';
  // production - old
  //public static FRONTEND_LINK = 'https://www.difmoe.eu/d/';
  //public static EDITOR_BACKEND_URL = 'https://difmoe.rychtar.cloud/editor';
  //public static IMAGE_UPLOAD_BACKEND_URL = 'http://www.difmoe.eu:3003';
  //public static JAVA_BACKEND_URL = 'https://backend.editor.difmoe.eu';
  // production - new
  //public static FRONTEND_LINK = 'https://www.difmoe.eu/d/';
  public static FRONTEND_LINK = 'https://difmoe.eu/';

  //public static EDITOR_BACKEND_URL = 'http://localhost:8080/kramerius-editor-backend/api/haruba';
  public static EDITOR_BACKEND_URL = 'https://api.difmoe.eu/kramerius-editor-backend/api/haruba';

  //public static IMAGE_UPLOAD_BACKEND_URL = 'http://www.difmoe.eu:3003';
  //public static IMAGE_UPLOAD_BACKEND_URL = 'http://localhost:8080/kramerius-editor-backend/api/hanoba';
  public static IMAGE_UPLOAD_BACKEND_URL = 'https://api.difmoe.eu/kramerius-editor-backend/api/hanoba';
  
  //public static JAVA_BACKEND_URL = 'https://backend.editor.difmoe.eu';

  //public static JAVA_BACKEND_BASE_URL = 'http://localhost:8080/kramerius-editor-backend';
  public static JAVA_BACKEND_BASE_URL = 'https://api.difmoe.eu/kramerius-editor-backend';

  //public static PERSISTENT_LINK = 'https://www.difmoe.trinera.cloud/uuid/';

  //public static MAJABA_BASE_URL = 'http://localhost:8080/kramerius-editor-backend/api/majaba';
  //PROD:
  //public static MAJABA_BASE_URL = 'https://api.difmoe.trinera.cloud/kramerius-editor-backend/api/majaba';

  //LOCAL
  //public static PIXELPRINT_KX_ADMIN_URL = 'http://localhost:4300';
  //PRODUCTION
  //public static PIXELPRINT_KX_ADMIN_URL = 'https://admin.difmoe.trinera.cloud';
  //OLD PROD
  //public static PIXELPRINT_KX_ADMIN_URL = 'https://admin.difmoe.eu';

  //PRODUCTION
  public static PIXELPRINT_KX_ADMIN_URL = 'https://admin.difmoe.eu';
  
  

  // local
  // public static FRONTEND_LINK = 'http://127.0.0.1:8080/#!/d/';
  // public static EDITOR_BACKEND_URL = 'http://localhost:3000/editor';
  // public static IMAGE_UPLOAD_BACKEND_URL = 'http://localhost:3003';
  // public static JAVA_BACKEND_URL = 'http://localhost:8080/editor-backend';


  // kfbz
  // public static INSTANCE = 'kfbz';
  // public static KRAMERIUS_URL = 'http://dlib.kfbz.cz';
  // public static ADD_PERSISTENT_LINK = false;
  // public static PERSISTENT_LINK = 'http://www.digitalniknihovna.cz/kfbz/uuid/';
  // // production
  // public static FRONTEND_LINK = 'http://www.digitalniknihovna.cz/kfbz/';
  // public static EDITOR_BACKEND_URL = 'http://kfbz.rychtar.cloud/editor';
  // public static IMAGE_UPLOAD_BACKEND_URL = 'http://upload.kfbz.rychtar.cloud';//TODO: opravdu, tohle je nasazene lokalne na jejich serveru
  // public static JAVA_BACKEND_URL = ''; 
  // // local
  // public static FRONTEND_LINK = 'http://127.0.0.1:8080/#!/kfbz/';
  // public static EDITOR_BACKEND_URL = 'http://localhost:3000/editor';
  // public static IMAGE_UPLOAD_BACKEND_URL = 'http://localhost:3003';
  // public static JAVA_BACKEND_URL = 'http://localhost:8080/editor-backend';



  static getFrontendLink(path: string, uuid: string): string {
    return Connector.FRONTEND_LINK + (path ? path + '/' : '') + uuid;
  }

  static getPersistentLink(uuid: string): string {
    return Connector.PERSISTENT_LINK + uuid;
  }


}
